import styled from 'styled-components';
import Select from 'react-select';
import { CourtList, FilterType, Region } from '../../search/FilterData';
import { SystemList } from '../../../interface/aiAnalyze/aiRecommend/data';
import { useState } from 'react';
import RegionOption from '../../search/filterOptionModal/RegionOption';
import OptionModal from '../../search/filterOptionModal/OptionModal';

interface Props {
  filters: FilterType;
  setFilters: (filters: any) => void;
  handleSearch: () => void;
}

function ScheduledAuctionFilter({ filters, setFilters, handleSearch }: Props) {
  const [openOption, setOpenOption] = useState<null | 'region'>(null);

  const closeModal = () => {
    setOpenOption(null);
  };

  const renderModal = () => {
    switch (openOption) {
      case 'region':
        return (
          <RegionOption
            onClose={closeModal}
            filters={filters}
            setFilters={setFilters}
            onlyRegion
          />
        );
    }
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '14px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '14px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };

  const handleReset = () => {
    setFilters({
      type: 'a',
      regionOrCourt: 'r',
      region: [] as Region[],
      court: '',
      belong: '',
      year: '',
      caseNumber: '',
      itemStatus: [],
      multiItemStatus: [],
      appraisalPrice: { min: '', max: '' },
      minPrice: { min: '', max: '' },
      saleDate: { start: '', end: '' },
      approvalDate: { start: '', end: '' },
      buildingArea: { min: '', max: '' },
      landArea: { min: '', max: '' },
      bidStatus: '',
      progressStatus: '진행',
      useArea: [],
      multiUseArea: [],
      specialConditionViewOption: 'o',
      specialItemCondition: [],
      multiSpecialItemCondition: [],
      holdingCompany: [],
      multiHoldingCompany: [],
      holder: '',
      debtor: '',
      creditor: '',
    });
  };

  return (
    <Container>
      <FilterRow>
        <FilterLabel>법원</FilterLabel>
        <FilterRowContent>
          <div style={{ width: '192px' }}>
            <Select
              options={CourtList}
              styles={{
                ...customStyles,
                control: (provided: any) => ({
                  ...customStyles.control(provided),
                }),
              }}
              value={
                filters.court === ''
                  ? null
                  : {
                      label: filters.court,
                      value: filters.court,
                    }
              }
              placeholder="법원 선택"
              onChange={(selectedOption) => {
                if (selectedOption) {
                  setFilters({ ...filters, court: selectedOption.value });
                }
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              menuPortalTarget={document.body}
              options={SystemList}
              styles={{
                ...customStyles,
                menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
              }}
              placeholder="계"
              value={
                filters.belong === ''
                  ? null
                  : {
                      label: filters.belong,
                      value: filters.belong,
                    }
              }
              onChange={(selectedOption) => {
                if (selectedOption) {
                  const selected = selectedOption.label;
                  setFilters({ ...filters, belong: selected });
                }
              }}
            />
          </div>
        </FilterRowContent>
      </FilterRow>

      <FilterRow>
        <FilterLabel>사건번호</FilterLabel>
        <FilterRowContent gap="8px">
          <div style={{ width: '104px' }}>
            <NumberInput
              type="number"
              pattern="[0-9]*"
              placeholder="연도"
              value={filters.year || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length <= 4) {
                  setFilters({
                    ...filters,
                    year: value,
                  });
                }
              }}
            />
          </div>
          <Text>타경</Text>
          <div style={{ flex: 1 }}>
            <NumberInput
              type="number"
              pattern="[0-9]*"
              placeholder="사건번호"
              value={filters.caseNumber || ''}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  caseNumber: e.target.value,
                })
              }
            />
          </div>
        </FilterRowContent>
      </FilterRow>

      <FilterRow>
        <FilterLabel>주소</FilterLabel>
        <OptionButton
          isNull={filters.region.length === 0}
          onClick={() => setOpenOption('region')}
        >
          <LocationOption>
            <img src="/assets/images/icon/location.svg" alt="" />
            {filters.region.length === 0 ||
            filters.region.every(
              (item) => !item.sido && !item.sigungu && !item.emd,
            )
              ? '지역'
              : filters.region
                  .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
                  .join(',')}
          </LocationOption>
          <img src="/assets/images/arrow/black_arrow_down_20.svg" alt="" />
        </OptionButton>
      </FilterRow>

      <FilterRow>
        <FilterLabel>이해관계인</FilterLabel>
        <FilterRowContent>
          <Input
            type="text"
            placeholder="소유자"
            value={filters.holder}
            onChange={(e) => {
              setFilters({ ...filters, holder: e.target.value });
            }}
          />
          <Input
            type="text"
            placeholder="채무자"
            value={filters.debtor}
            onChange={(e) => {
              setFilters({ ...filters, debtor: e.target.value });
            }}
          />
          <Input
            type="text"
            placeholder="채권자"
            value={filters.creditor}
            onChange={(e) => {
              setFilters({ ...filters, creditor: e.target.value });
            }}
          />
        </FilterRowContent>
      </FilterRow>

      <ButtonBox>
        <ResetButton onClick={handleReset}>
          <img src="/assets/images/icon/reset.svg" alt="" />
          <span>초기화</span>
        </ResetButton>
        <ApplyButton onClick={handleSearch}>검색</ApplyButton>
      </ButtonBox>

      {openOption !== null && (
        <OptionModal option={openOption} onClose={closeModal}>
          {renderModal()}
        </OptionModal>
      )}
    </Container>
  );
}

export default ScheduledAuctionFilter;

const Container = styled.div`
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0px 4px 24px 0px #3d454e1a;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FilterRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FilterLabel = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  display: flex;
`;

const FilterRowContent = styled.div<{ gap?: string }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${({ gap }) => (gap ? gap : '16px')};
`;

const NumberInput = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
  }
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: #f7f8fc;
  border: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;

  &::placeholder {
    color: #616161;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
  }
  -webkit-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ResetButton = styled.button`
  width: 61px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background-color: #fff;
  font-size: 12px;
  font-weight: 400;
  color: #616161;
  cursor: pointer;
`;

const ApplyButton = styled.button`
  flex: 1;
  height: 41px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  background-color: #008aff;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
`;

const OptionButton = styled.button<{ isNull?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  padding: 12px;
  background-color: #f7f8fc;
  justify-content: space-between;
  color: ${({ isNull }) => (isNull ? '#616161' : '#222222')};
  border: none;
  white-space: nowrap;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const LocationOption = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
